/**
 * exit Receipt
 */

// React
import React, { useEffect, useState } from 'react'

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import { WrapperReceipt } from './style'
import jMoment from 'moment-jalaali'
import Barcode from 'react-barcode'

// Type
import { Props } from '../interfaces'
import { formaterPhoneNumber, translate } from '../../../utils/helpers'
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import handleError from '../../../utils/handleError'
import RonadIcons from '../../../components/iconComponent'
import getLogo from 'client-sdk/src/partners/getLogo'

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '24px',
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8)
        }
      }
    }
  })
)

export function ExitOrderRecipt(props: Props) {
  const classes = useStyles()
  const [orderList, setOrderList] = useState([])
  const [loading, setLoading] = useState<boolean>(false)
  const [logo, setLogo] = useState<string>('')

  const orderId = props.match.params?.id.split(',')

  useEffect(() => {
    handleGetOrders(orderId)
  }, [])

  function* printAndClose() {
    yield window.print()
    yield window.close()
  }

  const printClose = printAndClose()

  useEffect(() => {
    if (orderList[0]?.id) {
      window.print()
    }
  }, [orderList])

  const getOrderWithId = async (actions: any) => {
    try {
      setLoading(true)
      const { response } = await ordersRepository.getOrders({
        payload: { ...actions }
      })
      setOrderList(response.data)
    } catch (error) {
      handleError(error)
    } finally {
      setLoading(false)
    }
  }

  const handleGetOrders = (orderId: []) => {
    getOrderWithId({
      'id.in': orderId
    })
  }

  // useEffect(() => {
  //   if (orderList.id) {
  //     getLogoFile()
  //     console.log(222222222222222222222)
  //   }
  // }, [orderList])

  useEffect(() => {
    if (orderList.id && logo) {
      setTimeout(() => {
        if (['pick', 'pack'].includes(query.get('from'))) {
          printClose.next()
          printClose.next()
        } else {
          window.print()
        }
      }, 1000)
    }
  }, [logo])

  // const getLogoFile = async () => {
  //   getLogo(orderList?.partnerId)
  //     .then((res) => {
  //       if (res.ok) {
  //         return res.blob()
  //       } else {
  //         throw new Error('error')
  //       }
  //     })
  //     .then((blob) => {
  //       if (blob.size > 0) {
  //         setLogo(URL.createObjectURL(blob))
  //       } else {
  //         setLogo('NONE')
  //       }
  //     })
  //     .catch((err) => {
  //       setLogo('NONE')
  //     })
  // }

  return (
    <WrapperReceipt className={classes.root}>
      {orderList?.map((order: any) => {
        return (order?.packages?.length > 0 ? order?.packages : [1])?.map(
          (page: any, index: number, arr: any) => (
            <div className='page'>
              <div className='pageInner'>
                <main>
                  {/* Sender section */}
                  <div className='section' style={{ marginBottom: '2px' }}>
                    <p className='lable'>فرستنده</p>
                    <div className='logo-section'>
                      {!['VITRIN', 'vitrin', 'ANAR'].includes(order.origin) ? (
                        <>
                          {logo && logo !== 'NONE' ? (
                            <img
                              width='120'
                              height='40'
                              src={logo}
                              alt='logo'
                            />
                          ) : (
                            <span
                              style={{
                                display: 'block',
                                fontSize: '12px',
                                fontWeight: 'bold',
                                width: '140px',
                                height: '40px'
                              }}
                            >
                              {order.senderName || order?.partnerName}
                            </span>
                          )}
                        </>
                      ) : (
                        <span
                          style={{
                            display: 'block',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            width: '140px',
                            height: '40px'
                          }}
                        >
                          {order?.description?.split('-')[0]}
                        </span>
                      )}
                      <p className='partner-address'>
                        {/* <span>
                          {order?.isUsingPartnerAddress
                            ? order.partnerAddress
                            : order?.fulfillmentWarehouseAddress}{' '}
                        </span> */}
                        <span>{order.centerAddress.slice(0, 130)}</span>
                        <br />
                        <span>
                          {`کدپستی: ${
                            order?.isUsingPartnerAddress
                              ? order.partnerZipCode
                              : order?.fulfillmentWarehouseZipCode
                          } `}
                        </span>
                        {!['VITRIN', 'vitrin', 'ANAR'].includes(
                          order.origin
                        ) ? (
                          <span>پشتیبانی: {order.partnerPhoneNumber}</span>
                        ) : (
                          <span>
                            پشتیبانی: {order?.description?.split('-')[1]}
                          </span>
                        )}
                      </p>
                    </div>
                    <div className='barcode-section'>
                      <p className='orderId'>
                        {order.parentId ? order.parentId : order.id}
                      </p>
                      <div className='tracking-code'>
                        <span>{order.trackingCode}</span>
                      </div>
                      <Barcode
                        fontSize={9}
                        fontOptions='bold'
                        // displayValue={false}
                        width={1.4}
                        value={order.parentId ? order.parentId : order.id}
                        height={'23px'}
                        background='White'
                      />
                    </div>
                  </div>
                  {/* Receiver section */}
                  <div
                    className='receiver-section'
                    style={{ marginTop: '7px' }}
                  >
                    <p className='lable' style={{ fontSize: '10px' }}>
                      گیرنده
                    </p>

                    {/* Receiver Name */}
                    <div className='receiver-name'>
                      <div className='flex-center'>
                        {/* <Icon path={mdiAccount} size={0.5} /> */}
                        <span style={{ marginRight: '1px', fontSize: '9px' }}>
                          {order?.customerName?.substring(0, 20)}
                        </span>
                      </div>
                      <div className='flex-center'>
                        {/* <Icon path={mdiPhone} size={0.5} /> */}
                        <span style={{ marginLeft: '15px', fontSize: '9px' }}>
                          {formaterPhoneNumber(order?.customerMobileNumber)}
                        </span>
                      </div>
                    </div>

                    {/* Receiver Address */}
                    <div style={{ padding: '0 4px' }}>
                      <div style={{ width: '100%' }}>
                        {/* mail */}
                        <div
                          style={{
                            fontSize: '9px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingTop: '2px'
                          }}
                        >
                          <div className='flex-center'>
                            {/* <Icon path={mdiMapMarker} size={0.5} /> */}
                            <span
                              style={{ marginRight: '1px', fontSize: '9px' }}
                            >
                              {order?.customerProvince} {order?.customerCity}
                            </span>
                          </div>
                          <div className='flex-center'>
                            {/* <Icon path={mdiEmailOutline} size={0.5} /> */}
                            <span style={{ fontWeight: 'bold' }}>
                              {'کد پستی: '}
                            </span>
                            <span>{order?.customerZipCode}</span>
                          </div>
                        </div>

                        {/* full address */}
                        <p
                          style={{
                            fontSize: '9px',
                            lineHeight: '14px',
                            marginTop: '3px',
                            marginBottom: '0',
                            height: '43px'
                          }}
                        >
                          <span>{order?.customerAddress}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Order table */}
                  <table className='order-table'>
                    <tr>
                      <td>
                        <div className='flex-center'>
                          {/* <Icon path={mdiCalendar} size={0.7} /> */}
                          <span
                            style={{
                              fontWeight: 'bold',
                              marginRight: '3px',
                              fontSize: '12px'
                            }}
                          >
                            {order?.deliveryDate &&
                              jMoment(order.deliveryDate, 'YYYY/MM/DD')
                                .locale('fa')
                                .format('jMM/jDD')}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className='flex-center'>
                          {/* <Icon path={mdiCreditCardOutline} size={0.7} /> */}
                          <span className='date-container'>
                            {' پرداخت '} {translate(order?.paymentType, 'cod')}
                            {order?.paymentType != 'ONLINE' && (
                              <span
                                style={{ fontSize: '7px', marginRight: '2px' }}
                              >
                                (هزینه دریافت شود)
                              </span>
                            )}
                          </span>
                        </div>
                      </td>
                      <td style={{ fontSize: '10px', fontWeight: 'bold' }}>
                        <div className='flex-center'>
                          {/* <Icon path={mdiArchive} size={0.5} /> */}
                          <span>تعداد فقره:</span> &nbsp;{' '}
                          {<span> {arr.length + ' / ' + (index + 1)}</span>}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className='flex-center'>
                          {/* <Icon path={mdiClockOutline} size={0.7} /> */}
                          <span
                            style={{
                              fontWeight: 'bold',
                              marginRight: '3px',
                              fontSize: '12px'
                            }}
                          >
                            {order?.deliveryEndTime &&
                              jMoment(order.deliveryEndTime, 'HH:mm:ss')
                                .locale('fa')
                                .format('HH')}
                            {' - '}
                            {order?.deliveryStartTime &&
                              jMoment(order.deliveryStartTime, 'HH:mm:ss')
                                .locale('fa')
                                .format('HH')}{' '}
                          </span>
                        </div>
                      </td>
                      <td>
                        {order.codValue && (
                          <div className='flex-center'>
                            {/* <Icon path={mdiCash} size={0.7} /> */}
                            <span>
                              <span
                                style={{
                                  marginRight: '10px',
                                  fontSize: '10px',
                                  fontWeight: 'bold'
                                }}
                              >
                                {order.codValue?.toLocaleString()}{' '}
                              </span>
                              <span
                                style={{ fontSize: '8px', marginRight: '2px' }}
                              >
                                ریال
                              </span>
                            </span>
                          </div>
                        )}
                      </td>
                      <td>
                        <div className='flex-start'>
                          {order.deliveryType == 'VIP' && (
                            <div className='flex-center'>
                              {/* <Icon path={mdiTruckFastOutline} size={1} /> */}
                            </div>
                          )}
                          {order?.courierMatching && (
                            <img
                              src='/truck-time.svg'
                              width='20px'
                              height='20px'
                              style={{ marginLeft: '5px' }}
                            />
                          )}
                          {['EXPRESS_POST', 'POST', 'SPECIAL_POST'].includes(
                            order.deliveryType
                          ) && (
                            <div className='flex-center'>
                              <img
                                src='/post2.png'
                                alt='post'
                                width='20px'
                                height='20px'
                              />
                            </div>
                          )}
                          {order.orderTPLType && (
                            <div className='flex-center'>
                              <img
                                src={`/${order.orderTPLType}-dark.png`}
                                alt={order.orderTPLType}
                                width='20px'
                                height='20px'
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  </table>

                  {/* Footer */}
                  <div
                    className='flex-center'
                    style={{ marginTop: '5px', padding: '0 20px' }}
                  >
                    <img
                      src='/ronadLogo.png'
                      alt='ronad'
                      width='10px'
                      height='15px'
                    />
                    <img
                      src='/nameLink.png'
                      alt='ronad'
                      width='30px'
                      height='15px'
                    />
                    <p
                      style={{
                        fontSize: '10px',
                        margin: '0',
                        marginRight: 'auto'
                      }}
                    >
                      پردازش و ارسال توسط خدمات هوشمند روناد
                    </p>
                  </div>
                </main>
              </div>
            </div>
          )
        )
      })}
    </WrapperReceipt>
  )
}

export default ExitOrderRecipt
